/* eslint-disable no-param-reassign */
export const formatVehicleRegNumber = regNumber => {
  if (!regNumber) return ''
  return regNumber
    .toUpperCase()
    .split('')
    .reduce((acc, char, idx, arr) => {
      const prevChar = arr[idx - 1]
      if (idx > 0 && isAlphaNumericTransition(prevChar, char)) {
        acc += '-'
      }
      acc += char
      return acc
    }, '')
}

export function isAlphaNumericTransition(a, b) {
  return (isLetter(a) && isDigit(b)) || (isDigit(a) && isLetter(b))
}

export function isLetter(char) {
  return /^[A-Z]$/.test(char)
}

export function isDigit(char) {
  return /^\d$/.test(char)
}
